import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
const API_BASE = 'userpreferences/v1/emailAddresses';
export default class EmailAddressesAPI {
  static getEmailAddresses() {
    return http.get(API_BASE, {
      portalId: PortalIdParser.get()
    });
  }
  static addEmailAddress(emailAddress) {
    return http.post(`${API_BASE}/${emailAddress}`, {
      portalId: PortalIdParser.get()
    });
  }
  static removeEmailAddress(emailAddress) {
    return http.delete(`${API_BASE}/${emailAddress}`, {
      portalId: PortalIdParser.get()
    });
  }
  static editEmailAddress(emailAddress) {
    return http.post(`${API_BASE}/edit/${emailAddress}`, {
      portalId: PortalIdParser.get()
    });
  }
  static resendPendingConfirmation() {
    return http.post(`${API_BASE}/resend/`, {
      portalId: PortalIdParser.get()
    });
  }
  static cancelPendingEmailAddress() {
    return http.post(`${API_BASE}/cancelPending/`, {
      portalId: PortalIdParser.get()
    });
  }
}